// Gradient Line Chart
import {
    Pie
} from 'vue-chartjs'
import {
    ChartConfig
} from "Constants/chart-config"
import {
    hexToRgbA
} from 'Helpers/helpers'

const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
})

const labelFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
})

export default {
    extends: Pie,
    data() {
        return {
            gradient: null,
            gradient2: null
        }
    },
    props: {
        values: {
            type: Array,
            required: true
        },
        isMoneyValue: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        values: {
            handler: function(newValues, oldValues) {
                console.log("Values changed in PieChartChannels.js, re-rendering chart");
                if (newValues && newValues.length > 0) {
                    // Wir rufen die render-Methode direkt auf, da diese bereits
                    // das bestehende Chart zerstört und ein neues erstellt
                    this.render();
                }
            },
            deep: true // Um tief verschachtelte Änderungen zu überwachen
        }
    },
    methods: {
        render() {
            const self = this
            
            // Überprüfe, ob Werte vorhanden sind
            if (!this.values || this.values.length === 0) {
                console.log("No values to render in pie chart");
                return;
            }
            
            console.log("Rendering pie chart with values:", this.values);
            
            // Zerstöre das bestehende Chart, falls vorhanden
            if (this.$data._chart) {
                console.log("Destroying existing chart");
                this.$data._chart.destroy();
            }
            
            // Warte auf den nächsten Tick, um sicherzustellen, dass das DOM aktualisiert wurde
            this.$nextTick(() => {
                console.log("Creating new chart with segments:", this.values.length);
                this.renderChart({
                    labels: this.values.map(item => item.label),
                    datasets: [{
                        label: 'Data',
                        borderColor: '#ffffff',
                        pointBorderColor: this.gradient,
                        pointBackgroundColor: this.gradient,
                        pointHoverBackgroundColor: this.gradient,
                        pointHoverBorderColor: this.gradient,
                        pointBorderWidth: 10,
                        pointHoverRadius: 10,
                        pointHoverBorderWidth: 1,
                        pointRadius: 3,
                        fill: true,
                        backgroundColor: this.values.map(item => item.backgroundColor || item.color),
                        borderWidth: 1,
                        data: this.values.map(item => item.value)
                    }]
                }, {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        position: 'bottom',
                        display: true,
                        labels: {
                            boxWidth: 12,
                            padding: 10,
                            fontSize: 12
                        }
                    },
                    plugins: {
                        colorschemes: {
                            scheme: 'tableau.Classic20'
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                const formatter = new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                    minimumFractionDigits: 2,
                                })
                                
                                const dataValue = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                                const label = data.labels[tooltipItem.index]
                                
                                // Extrahiere den Prozentsatz aus dem Label, falls vorhanden
                                const percentageMatch = label.match(/\(([0-9.]+)%\)/);
                                const percentageText = percentageMatch ? ` (${percentageMatch[1]}%)` : '';
                                
                                // Entferne den Prozentsatz aus dem Label für die Anzeige
                                const cleanLabel = label.replace(/\s*\([0-9.]+%\)/, '');
                                
                                return `${cleanLabel}: ${self.isMoneyValue ? formatter.format(dataValue) : dataValue}${percentageText}`;
                            }
                        }
                    }
                });
            });
        }
    },
    mounted() {
        this.gradient = this.$refs.canvas.getContext('2d').createLinearGradient(500, 0, 100, 0)
        this.gradient2 = this.$refs.canvas.getContext('2d').createLinearGradient(500, 0, 100, 0)

        this.gradient.addColorStop(0, ChartConfig.color.danger)
        this.gradient.addColorStop(1, ChartConfig.color.warning)

        this.gradient2.addColorStop(0, hexToRgbA(ChartConfig.color.danger, 0.6))
        this.gradient2.addColorStop(1, hexToRgbA(ChartConfig.color.warning, 0.6))
        this.render()
    }
}